/**
 * Font Checking
 */

(function () {

	'use strict';

	// var knockout = new FontFaceObserver('Knockout 27 A, Knockout 27 B', {
	// 	weight: 400
	// });

	// Promise.all([
	// 	knockout.check(null, 6000),
	// ]).then(function () {
	// 	document.documentElement.className += ' ct-active';
	// }, function (err) {
	// 	console.error(err);
	// });

	document.documentElement.className += ' ct-active';

})();
